import React from "react";
import { Bar } from 'react-chartjs-2';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

  import "chartjs-plugin-datalabels";
  import {
    Chart as ChartJS,
    CategoryScale,
    
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from "chart.js";
  import ChartDataLabels from 'chartjs-plugin-datalabels';
  import 'chart.js/auto';

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels // Register the DataLabels plugin
  );
  

  const BarChartPolicies = (props) => {
const { t } = useTranslation();
    
  const options = {
  responsive: true,
  maintainAspectRatio: false,
   layout: {
      padding: {
        top: 22,
        right: 22,
        left: 22
      }
    },
   scales: {
    x: {
        display: true,
    },
          y: {
            
        display: true,
        title: {
          display: true,
          text: t(props.titleY),
        
           color: "rgb(84, 84, 84)", 
            font: {
              size: 13,
              weight: "500",
            },
        padding: {top: 30, left: 0, right: 0, bottom: 0}
        }
      }
    },
  plugins: {
    legend: {
      display: true,
     position: "bottom",
           onClick: null

    },
      datalabels: {
          align: 'end',
            anchor: 'end',
            color: "black", 
            font: {
              size: 14,
              weight: "500",
            },
  },
},

  };


const labels = [""];

const dataSet = {
  labels,
  datasets: [
    {
    label: t('graphs_legend_yes'),
      data: [props.data[0]],
      backgroundColor: "rgb(138, 206, 126)",
    },
    {
    label:  t('legend_initiated'),
      data: [props.data[1]],
      backgroundColor: "rgb(240, 189, 39)",
    },
    {
    label:  t('legend_no'),
      data:  [props.data[2]],
      backgroundColor: "rgb(225, 53, 49)",
    },
    {
    label:  t('graphs_legend_no_info'),
      data:  [props.data[3]],
      backgroundColor: "rgb(92, 96, 104)",
    },
  ],
};
    return (
      <div >

      <Card className="card-padding-always">
      <Card.Header className="container-header" >
        <p className="vertical-center card-title" >{t(props.graphTitle)}</p></Card.Header>
      <Card.Body> 
        <div className={props.isSubquestion ? "graph-div-subquestion" : 
          "graph-div-main"}>
         <Bar options={options} data={dataSet} className="graph-height-mobile" />
         </div>
       </Card.Body>
    </Card> 


   
      </div>
    );
  };
  
  export default BarChartPolicies;
  
